// @ts-nocheck
import DebugForm from 'Components/DebugForm'
import Loader from 'Components/Loader'
import { initDump } from 'Core/DebugUtils'
import { FeatureFlagProvider } from 'Core/FeatureFlagContext'
import { lazyWithRetry } from 'Core/lazyWithRetry'
import BootProvider from 'Core/Hooks/useBoot/BootProvider'
import { fetchAllCloudResources } from 'features/clouds/utils/CloudResourcesSlice'
import { AuthenticatedRoute } from 'features/layout'
import React, { Suspense, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch } from 'react-router-dom'
import { Routes } from 'routes'
import { debug } from 'Utils/DebugHelper'

const Register = lazyWithRetry(() => import('./Views/Register'))
const MFARoutes = lazyWithRetry(() =>
  import('features/mfa').then((m) => ({ default: m.MFARoutes }))
)

window.debug = debug

initDump()

const App = () => {
  const isAuthenticated = useSelector((state) => state.user.loggedIn)

  return (
    <BootProvider>
      {/* Suspense is required here: /register and /mfa are lazy and have no
          other boundary above them. */}
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route path='/register' component={Register} />
          <Route path='/mfa' component={MFARoutes} />
          <FeatureFlagProvider Fallback={<Loader />}>
            <AuthenticatedRoute isAuthenticated={isAuthenticated} path='/' component={Routes} />
          </FeatureFlagProvider>
        </Switch>
        <DebugForm />
      </Suspense>
    </BootProvider>
  )
}

export default App
